module.exports = __webpack_public_path__ + "img/Illustration.0a94f143.png";